import { useEffect, useReducer } from 'react';
import { ensureImmutability } from './ensureImmutability';
export function useSubscribeStore(store, event, selector) {
    var _a = useReducer(function () {
        var v = selector(store.getState());
        return ensureImmutability(v);
    }, selector(store.getState())), value = _a[0], dispatch = _a[1];
    useEffect(function () {
        var unsubscribe = store.subscribe(event, dispatch);
        return function () {
            unsubscribe();
        };
    }, [store.subscribe]);
    return value;
}
//# sourceMappingURL=useSubscribeStore.js.map